(function($) {
	'use strict';

	// Prevent middle clicking on tabs
	$(document).on('click.shown.bs.tab', function(e) {
		if (e.which === 2 &&
		    $(e.target).closest('[data-toggle="tab"]').length > 0) {
			e.preventDefault();
		}
	});

	// If tab or pill are switched externally we update tab panel
	$(document).on('click.shown.bs.tab', '[data-toggle="tab"]', function() {
		var $self = $(this);
		activateNavElement(this.hash);

		if ($self.attr('data-pill')) {
			activateTabPane($self.data('pill'));
		}

		if ($self.attr('data-tabs-container')) {
			var tabContainer = $self.attr('data-tabs-container');
			var tabName = $self.attr('data-tab-link-name') ? $self.attr('data-tab-link-name') : $self.text();
			changeLinkUrl(tabContainer, tabName);
		}

		return MOD.WfEasyXdm.sendMessage({'ALIVE': ''});
	});

	function activateNavElement(hash) {
		var $navLinks = $('li > a[data-toggle=tab]');
		var $navLis = $navLinks.parent();
		var $activatedNavLinks = $navLis.find('[href="' + hash + '"]');
		var $activatedNavLis = $activatedNavLinks.parents('ul').find('li');

		var tabName = $activatedNavLinks.text();
		F2.Events.emit('TAB_CHANGE', {tabName: tabName});

		$activatedNavLis.removeClass('active');
		$activatedNavLinks.parent().addClass('active');
	}

	function activateTabPane(hash) {
		activateNavElement(hash);

		var $pane = $(hash);
		var $panes = $pane.siblings();

		$panes.removeClass('active in');
		$pane.removeClass('fade');
		$pane.addClass('in active');
	}

	function changeLinkUrl(data, tabName) {
		var $link = $('a[data-tabs-container=' + data + ']:not([role="tab"])');
		var linkHref = $link.attr('href').replace(/#[^#]*$/, '');
		linkHref += '#tab=' + tabName;
		$link.attr('href', linkHref);
	}

})(jQuery);
